module.exports = __webpack_public_path__ + "static/media/video_image4.90d798d6.svg";